<ng-container *transloco="let t">
  @if(data.dismissible) {
  <div class="absolute top-0 right-0 pt-4 pr-4">
    <button mat-icon-button [matDialogClose]="undefined">
      <i class="iconify opacity-50!" data-icon="mdi:close"></i>
    </button>
  </div>
  }
  <mat-dialog-content>
    @if(data) {
    <div class="flex flex-col p-4 pb-2 pt-6 sm:pb-4 gap-6">
      <div class="flex flex-col sm:flex-row flex-auto items-center sm:items-start">
        @if(data.icon?.name) {
        <div class="flex flex-0 items-center justify-center sm:mr-4" [style.color]="iconColor()">
          <i class="iconify text-4xl" [attr.data-icon]="data.icon?.name"></i>
        </div>
        }
        @if(data.title || data.message) {
        <div class="flex flex-col items-center sm:items-start mt-4 sm:mt-0 sm:pr-8 space-y-1 text-center sm:text-left">
          @if(data.title) {
          <div class="text-xl leading-6 font-medium text-slate-900 dark:text-white">{{data.title}}</div>
          }
          @if(data.message) {
          <div class="">{{data.message}}</div>
          }
        </div>
        }
      </div>

      @if(data.type === 'input') {
      <mat-form-field class="fuse-mat-dense w-full" hideRequiredMarker="true">
        @if(data.label) {<mat-label>{{data.label}}</mat-label>}
        <input matInput type="text" [(ngModel)]="result.text" name="text" #text="ngModel" [required]="data.required!"
               cdkFocusInitial>
        @if(text.hasError('required') && text.touched) {
        <mat-error>{{data.label}} {{t('is required')}}</mat-error>
        }
      </mat-form-field>
      }
    </div>
    }
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    @if(has('ignore')) { <button mat-raised-button (click)="confirm({action: 'ignore'})">{{t('Ignore')}}</button> }
    @if(has('no')) { <button mat-raised-button (click)="confirm({action: 'no'})">{{t('No')}}</button> }
    @if(has('noSave')) { <button mat-raised-button (click)="confirm({action: 'noSave'})">{{t('NoSave')}}</button> }
    @if(has('cancel')) { <button mat-raised-button (click)="confirm({action: 'cancel'})">{{t('Cancel')}}</button> }

    @if(has('abort')) {
    <button mat-raised-button id="abort" (click)="confirm({action: 'abort'})">{{t('Abort')}}</button>
    }
    @if(has('confirm')) {
    <button mat-raised-button id="confirm" [color]="data.confirm?.color"
            [disabled]="data.type === 'input' && !result.text.length"
            (click)="confirm({action: 'confirm'})">
      {{t('Confirm')}}
    </button>
    }
    @if(has('ok')) {
    <button mat-raised-button id="ok" [color]="data.confirm?.color"
            [disabled]="data.type === 'input' && !result.text.length" (click)="confirm({action: 'ok'})">
      {{t('Ok')}}
    </button>
    }
    @if(has('save')) {
    <button mat-raised-button id="save" [color]="data.confirm?.color"
            [disabled]="data.type === 'input' && !result.text.length"
            (click)="confirm({action: 'save'})">
      {{t('Save')}}
    </button>
    }
    @if(has('yes')) {
    <button mat-raised-button id="yes" [color]="data.confirm?.color"
            [disabled]="data.type === 'input' && !result.text.length" (click)="confirm({action: 'yes'})">
      {{t('Yes')}}
    </button>
    }
    @if(has('retry')) {
    <button mat-raised-button id="retry" [color]="data.confirm?.color"
            [disabled]="data.type === 'input' && !result.text.length"
            (click)="confirm({action: 'retry'})">
      {{t('Retry')}}
    </button>
    }
  </mat-dialog-actions>
</ng-container>
